import React from 'react'
import { SkillCard } from '../Conteudo/Skills/SkillBar';
import { SkillCardSoft } from '../Conteudo/Skills/SkillBarSoft';
import { SkillSection } from './style'

export const SkillUser = () => {
    const BaseHardSkill = [
        {
          name: "HTML 5",
          level: "Avançado",
        },
        {
          name: "CSS",
          level: "Avançado",
        },
        {
          name: "JavaScript",
          level: "Avançado",
        },
        {
          name: "React",
          level: "Avançado",
        },
        {
          name: "TypeScript",
          level: "Intermediário",
        },
        {
          name: "GitHub",
          level: "Avançado",
        },
        {
          name: "Hooks",
          level: "Intermediário",
        },
        {
          name: "Git",
          level: "Avançado",
        },
        {
          name: "Bibliotecas de componentes",
          level: "Avançado",
        },
        {
          name: "Consumo de APIs",
          level: "Avançado",
        },
        {
          name: "Program. Orient. a Obj.",
          level: "Intermediário",
        },
        {
          name: "Lógica de programação",
          level: "Avançado",
        },
        {
          name: "NextJS",
          level: "Intermediário",
        },
        {
          name: "Postgresql",
          level: "Intermediário",
        },
        {
          name: "Python",
          level: "Intermediário",
        },
        {
          name: "Django",
          level: "Intermediário",
        },
      ];
    
      const BaseSoftSkill = [
        {
          name: "Comunicação clara e assertiva",
        },
        {
          name: "Produtividade",
        },
        {
          name: "Metodologias ágeis",
        },
        {
          name: "Boa gestão de tempo",
        },
        {
          name: "Colaboração",
        },
        {
          name: "Notion",
        },
        {
          name: "Kaban",
        },
      ];

  return (
    <SkillSection id='Skills'>
        <h2 className='titulo-section' data-aos="fade-right">Skills</h2>
        <div className='divUl'>
            <ul className='ulList left'>
                {
                    BaseHardSkill.map((item, index) => (
                        <SkillCard key={index} name={item.name} level={item.level} />
                    ))
                }
            </ul>
            <ul className='ulList right'>
                {
                    BaseSoftSkill.map((item, index) => (
                        <SkillCardSoft key={index} name={item.name} />
                    ))
                }
            </ul>
        </div>
        
        
    </SkillSection>
  )
}
